export default "__VITE_ASSET__iv1aCDo$__"